module.exports = __webpack_public_path__ + "static/media/movi-rate.65059d04.mov";